
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pdf-to-word",
      function () {
        return require("private-next-pages/pdf-to-word.js");
      }
    ]);
  